import UPSnackBar from 'components/app-container/snackbar/UPSnackbar';
import { Toast } from './hooks/useToasts';

interface ComplianceToastsProps {
  toasts: Toast[];
  onDismiss: (id: number) => void;
}

const ComplianceToasts = ({ toasts, onDismiss }: ComplianceToastsProps): JSX.Element => (
  <>
    {toasts.map((toast, index) => (
      <UPSnackBar
        key={toast.id}
        open
        type={toast.type}
        content={toast.content}
        onClose={() => onDismiss(toast.id)}
        vertical="bottom"
        horizontal="right"
        index={index}
      />
    ))}
  </>
);

export default ComplianceToasts;
